import { Paid } from "@mui/icons-material";
import { Alert, Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { AutoCompleteAsyncHookForm, DateInput, MonthInput, YearInput } from "components";
import { Fragment } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { selectChiffreAffaireFilter, setChiffreAffaireFilter } from "reducers";
import { ChiffreAffaireParAgence, ChiffreAffaireParClient, ChiffreAffaireParSecteur } from "./ca";

export const TYPE_DATA = [
  { label: "CA par client", value: "ca_client" },
  { label: "CA par secteur", value: "ca_secteur" },
  { label: "CA par agence", value: "ca_agence" },
];

export const PERIODES = [
  { label: "Par jour", value: "daily" },
  { label: "Par semaine", value: "hebdo" },
  { label: "Par mois", value: "mensuel" },
];

const ChiffreAffaire = () => {
  const filter = useSelector(selectChiffreAffaireFilter);
  const dispatch = useDispatch();
  const methods = useForm({ defaultValues: filter });
  const monthlyOnly = filter?.type?.value !== "ca_client";

  const setFilter = (name: string, value: any) => {
    const next = { ...filter, [name]: value };
    if (name === "type" && value?.value !== "ca_client") {
      next.periode = PERIODES[2];
      methods.setValue("periode", PERIODES[2]);
    }
    dispatch(setChiffreAffaireFilter(next));
  };

  const renderContent = () => {
    if (filter?.type?.value === "ca_secteur") return <ChiffreAffaireParSecteur />;
    if (filter?.type?.value === "ca_agence") return <ChiffreAffaireParAgence />;
    return <ChiffreAffaireParClient />;
  };

  return <Box sx={{ pb: 4 }}>
    <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center" }} spacing={2} sx={{ pt: 2, mb: 3 }}>
      <Box>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 700, letterSpacing: ".12em" }}>Pilotage commercial</Typography>
        <Typography variant="h2" sx={{ fontWeight: 700, letterSpacing: "-.025em" }}>Chiffre d’affaires</Typography>
        <Typography color="text.secondary">Comparez le revenu de transport par client, secteur d’activité ou agence.</Typography>
      </Box>
      <Box sx={{ width: 52, height: 52, display: "grid", placeItems: "center", borderRadius: 2, bgcolor: "primary.lighter", color: "primary.main" }}><Paid sx={{ fontSize: 30 }} /></Box>
    </Stack>

    <FormProvider {...methods}>
      <Paper variant="outlined" sx={{ p: { xs: 2, md: 2.5 }, mb: 2.5, borderLeft: "4px solid", borderLeftColor: "primary.main" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}><AutoCompleteAsyncHookForm label="Ventilation" name="type" defaultOptions={TYPE_DATA} afterSelected={setFilter} /></Grid>
          <Grid item xs={12} sm={6} md={3}><AutoCompleteAsyncHookForm label="Période" name="periode" defaultOptions={monthlyOnly ? [PERIODES[2]] : PERIODES} afterSelected={setFilter} /></Grid>
          {filter?.periode?.value === "mensuel" ? <Fragment>
            <Grid item xs={12} sm={6} md={3}><MonthInput name="mois" label="Mois" afterSelected={setFilter} /></Grid>
            <Grid item xs={12} sm={6} md={3}><YearInput name="annee" label="Année" afterSelected={setFilter} /></Grid>
          </Fragment> : filter?.periode?.value === "hebdo" ? <Fragment>
            <Grid item xs={12} sm={6} md={3}><DateInput name="dateDebut" label="Date de début" afterSelected={setFilter} /></Grid>
            <Grid item xs={12} sm={6} md={3}><DateInput name="dateFin" label="Date de fin" afterSelected={setFilter} /></Grid>
          </Fragment> : <Grid item xs={12} sm={6} md={3}><DateInput name="date" label="Date" afterSelected={setFilter} /></Grid>}
        </Grid>
        {monthlyOnly ? <Alert severity="info" sx={{ mt: 2 }}>Les analyses par secteur et par agence sont disponibles par mois.</Alert> : null}
      </Paper>
    </FormProvider>

    <Paper variant="outlined" sx={{ overflow: "hidden" }}>{renderContent()}</Paper>
  </Box>;
};

export default ChiffreAffaire;
